import React from "react";
//import dayjs from "dayjs";
import { Link, useHistory } from "react-router-dom";

import "./header.css";

import { StoreContext } from "app/context/Store";
import MobileMenuIcon from "../../components/Icons/Mobile-Menu-Icon/MobileMenuIcon";
import { NOTIFICATION_DATA } from "app/context/Types";
import { useMutation } from "react-query";
import { useGet } from "app/services/http-service";
import { DOWNLOAD_IMAGE, GET_NOTIFICATIONS, NOTIFICATION_SUMMARY } from "app/api/ApiEndpoints";


function Header() {
  const history = useHistory();
  const context = React.useContext(StoreContext);
  const { state } = React.useContext(StoreContext);
  //const id = state?.clientConfigData?.id;
  const authToken = localStorage.getItem("tspAuthToken");
  const isSSO_LOGIN = localStorage.getItem('loggedInUsingSSO');
  
  const {
    mutate: getNotifications,
    data: notifications,
    isSuccess: getnotificationssuccessfully,
  } = useMutation((data) => useGet(data));
  const {
    mutate: getNotificationSummary,
    data: notificationSummary,
  } = useMutation((data) => useGet(data));

  const isVisibleCart = React.useMemo(() => {
    if (state?.clientConfigData) {
      return state?.clientConfigData?.clientConfigs?.filter(
        (item) => item.name === "allow_multiple_bill_pay",
      );
    }
  }, [state?.clientConfigData]);

  const homeButtonText = React.useMemo(() => {
    if (state?.clientConfigData) {
      const linkItem = context.state.clientConfigData.clientConfigs.find(
        (c) => c.name === "back-button-text",
      );
      return linkItem?.value || "Home";
    }
  }, [state?.clientConfigData]);

  const BACK_URL = React.useMemo(() => {
    if (state?.clientConfigData) {
      const linkItem = context.state.clientConfigData.clientConfigs.find(
        (c) => c.name === "back-button-url",
      );
      window.sso_back_button_url = linkItem?.value;
      return linkItem?.value;
    }
  }, [state?.clientConfigData]);

  React.useEffect(() => {
    const body = {
      url: GET_NOTIFICATIONS,
      token: authToken,
    };
    getNotifications(body);
    getNotificationSummary(
      {
        url: NOTIFICATION_SUMMARY,
        token: authToken
      }
    );
  }, []);

  React.useEffect(() => {
    if (notifications && getnotificationssuccessfully) {
      context.dispatch({
        type: NOTIFICATION_DATA,
        payload: { ...context.state, notificationsData: notifications },
      });
    }
  }, [getnotificationssuccessfully, notifications]);

  return (
    <nav
      className="navigation d-flex justify-content-between align-item-center payu-logo"
      onClick={() => document.body.classList.remove("effect")}
    >
      <Link to="/home">
        <img
          src={DOWNLOAD_IMAGE + "?key=" + state?.clientConfigData?.logo}
          alt="client-logo"
          height="45px"
          className="logo"
        />
      </Link>

      <span
        className="mobile-menu-icon"
        onClick={() =>
          (document.getElementById("sideBar").style.display = "block")
        }
      >
        <MobileMenuIcon />
      </span>
      <div className="menu_items">
        <ul>
          {false && (
            <li>
              <i className="material-icons">search</i>
            </li>
          )}
          {isVisibleCart && isVisibleCart[0]?.value === "true" && (
            <li>
              <i className="material-icons">local_grocery_store</i>
            </li>
          )}
          {(BACK_URL && isSSO_LOGIN) && (
              <li>
                <a
                    className="font-weight-bold cursor-pointer"
                    href={BACK_URL}
                    onClick={(e) => {
                      // Prevent the default navigation temporarily
                      e.preventDefault();

                      // Clear sessionStorage
                      sessionStorage.removeItem("app_logo");
                      sessionStorage.removeItem("app_title");

                      // Then navigate programmatically
                      window.location.href = BACK_URL;
                    }}
                >
                  <span className="header-span-text margin_right"> {homeButtonText} </span>
                </a>
              </li>
          )}
          {/* <li className="moback_btn">}
            <a className="font-weight-bold cursor-pointer">
              <span className="header-span-text">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48"><path d="M17.95 35.9 6 23.95 17.95 12l2.15 2.15-8.3 8.3H42v3H11.8l8.3 8.3Z" /></svg></span>
            </a>
          </li>*/}

          <li onClick={() => history.push("/notifications")}>
            <div className="btn-group">
              <i className="material-icons">notifications_none</i>
              <span className="count count-red">
                {notificationSummary?.false ? notificationSummary?.false : 0}
              </span>
            </div>
          </li>

          <li>
            <p
              className="font-weight-bold cursor-pointer"
              onClick={() => history.push("/help")}
            >
              <span className={"header-span-text"}>Help ?</span>
            </p>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;
